import React, { useState } from 'react'
import MenuIcon from '../../assets/menu-icon.svg'
import EditIconBlack from '../../assets/edit-icon-black.svg'
import TrashIconDark from '../../assets/trash-icon-dark.svg'
import CopyIconDark from '../../assets/copy-dark.svg'
import ArrowUpDark from '../../assets/arrow-up-dark.svg'
import ArrowDownDark from '../../assets/arrow-down-dark.svg'

const EditMenu = ({
  onEdit = false,
  onMoveUp = false,
  onCopy = false,
  onMoveDown = false,
  onDelete = false,
  position = 'top-4 right-10',
  menuPosition = 'top-8 right-10',
}) => {
  const [showMenu, setShowMenu] = useState(false)
  return (
    <div className=" position-relative" style={{ zIndex: 50 }}>
      <div
        style={{
          width: '53px',
          borderRadius: '2px',
          boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.4)',
          height: '15px',
        }}
        className={`cursor-pointer bg-white flex justify-center items-center absolute ${position}  z-10`}
        onClick={() => setShowMenu(!showMenu)}
      >
        <img src={MenuIcon} className="" alt="MenuIcon" />
      </div>
      {showMenu && (
        <div
          className={` flex justify-content-between absolute ${menuPosition} z-10`}
          style={{
            borderRadius: '2px',
            boxShadow: '0 3px 4px 0 rgba(0, 0, 0, 0.39)',
            backgroundColor: '#fff',
          }}
        >
          {onEdit && (
            <div
              style={{ width: '28px', height: '28px' }}
              className="flex justify-content-center align-items-center cursor-pointer hover:bg-[#d5d5d5]"
              onClick={onEdit}
            >
              <img
                style={{ width: '13.9px', height: '13.9px' }}
                src={EditIconBlack}
                className=""
                alt="edit icon"
              />
            </div>
          )}
          {onMoveDown && (
            <div
              style={{ width: '28px', height: '28px' }}
              className="flex justify-content-center align-items-center cursor-pointer hover:bg-[#d5d5d5]"
              onClick={onMoveDown}
            >
              <img
                style={{ width: '7.9px', height: '11.8px' }}
                src={ArrowDownDark}
                className=""
                alt="ArrowDownDark icon"
              />
            </div>
          )}
          {onMoveUp && (
            <div
              style={{ width: '28px', height: '28px' }}
              className="flex justify-content-center align-items-center cursor-pointer hover:bg-[#d5d5d5]"
              onClick={onMoveUp}
            >
              <img
                style={{ width: '7.9px', height: '11.8px' }}
                src={ArrowUpDark}
                className=""
                alt="ArrowUpDark icon"
              />
            </div>
          )}

          {onCopy && (
            <div
              style={{ width: '28px', height: '28px' }}
              className="flex justify-content-center align-items-center cursor-pointer hover:bg-[#d5d5d5]"
              onClick={onCopy}
            >
              <img
                style={{ width: '9.5px', height: '11.8px' }}
                src={CopyIconDark}
                className=""
                alt="CopyIconDark icon"
              />
            </div>
          )}

          {onDelete && (
            <div
              style={{ width: '28px', height: '28px' }}
              className="flex justify-content-center align-items-center cursor-pointer hover:bg-[#d5d5d5]"
              onClick={onDelete}
            >
              <img
                style={{ width: '8.8px', height: '11.8px' }}
                src={TrashIconDark}
                className=""
                alt="TrashIconDark icon"
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default EditMenu
